export default function TextOutput({ value, onCopy, copyLabel }) {
  return (
    <div className="flex flex-col gap-2">
      <textarea
        className="sb-input h-48 resize-none"
        value={value}
        readOnly
        placeholder="Hier erscheint der generierte Text"
      />
    </div>
  );
}
